import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {adminRequest, buildQuery, getReturnedObject} from "../../api/adminApi";

const pageInfoFrom = (data: any) => ({
  pageNumber: data?.pageNumber || 1,
  pageSize: data?.pageSize || 10,
  totalItems: data?.totalRecords || 0,
  totalPages: Math.ceil((data?.totalRecords || 0) / (data?.pageSize || 10)),
});

type AuditTrailFilters = {
  token: string;
  searchParam?: string;
  userEmail?: string;
  method?: string;
  statusCode?: string | number;
  riskLevel?: string;
  isError?: string | boolean;
  isBlocked?: string | boolean;
  startDate?: string;
  endDate?: string;
  pageNumber?: number;
};

const initialState = {
  records: null as any[] | null,
  selectedAudit: null as any,
  summary: null as any,
  loading: false,
  error: undefined as string | undefined,
  pageInfo: {pageNumber: 1, pageSize: 10, totalItems: 0, totalPages: 0},
};

export const getAuditTrails = createAsyncThunk<any, AuditTrailFilters>(
  "auditTrail/list",
  async (data) =>
    adminRequest(`/audit-trails${buildQuery({
      searchParam: data.searchParam,
      userEmail: data.userEmail,
      method: data.method,
      statusCode: data.statusCode,
      riskLevel: data.riskLevel,
      isError: data.isError,
      isBlocked: data.isBlocked,
      startDate: data.startDate,
      endDate: data.endDate,
      pageNumber: data.pageNumber || 1,
      pageSize: 10,
    })}`, {token: data.token})
);

export const getAuditTrailById = createAsyncThunk<any, {token: string; auditId: string}>(
  "auditTrail/detail",
  async (data) => adminRequest(`/audit-trails/${data.auditId}`, {token: data.token})
);

const auditTrailSlice = createSlice({
  name: "auditTrail",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAuditTrails.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(getAuditTrails.fulfilled, (state, action) => {
        const report = getReturnedObject(action.payload);
        state.loading = false;
        state.summary = report;
        state.records = (report?.records || []).map((item: any) => ({...item, key: item.id}));
        state.pageInfo = pageInfoFrom(report);
      })
      .addCase(getAuditTrailById.pending, (state) => {
        state.loading = true;
        state.error = undefined;
        state.selectedAudit = null;
      })
      .addCase(getAuditTrailById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedAudit = getReturnedObject(action.payload);
      })
      .addCase(getAuditTrails.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message;
      })
      .addCase(getAuditTrailById.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message;
      });
  },
});

export default auditTrailSlice.reducer;
